import React, { useCallback, useEffect, useState } from 'react';
import {
  Modal,
  ModalContent,
  ShopLogoContainer,
} from './DownloadAppPopup.style';
import PlayStoreIcon from '../../assets/icons/google-play-badge.png';
import AppStoreIcon from '../../assets/icons/App-store-badge.svg';
import DelishopLogo from '../../assets/icons/delishop_logo2.svg';
import AppService from './services/index';
import { Button } from '@material-ui/core';

const DownloadAppPopupV2 = ({ deviceType: { mobile, tablet, desktop } }) => {
  const OpenAppLink = 'https://delishopasia.page.link/open-app';
  const appDownloadSession = sessionStorage.getItem('app_download_seasion');

  // Detect the mobile operating system
  const getMobileOS = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) return 'Android';
    if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
      return 'iOS';
    return 'Other';
  };

  const os = getMobileOS();
	const [showModal, setShowModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const fallbackLink = AppService.fallBackLink(window.location); // Web fallback
  const appLink = AppService.checkLink(window.location); // Deep link

  //app url without query filter
  const APP_URL = process.env.REACT_APP_APP_URL;
  
  const handleCloseModal = useCallback(() => {
    sessionStorage.setItem("app_download_seasion", "1");
    sessionStorage.removeItem("pageSource");
    setCloseModal(true);
  }, []);

  useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl.includes(APP_URL)) {
      setCloseModal(true);
      setTimeout(() => {
        window.location.href = OpenAppLink;
      }, 800);
    }
  }, [fallbackLink]);

  const handleClickOpenApp = () => {
    let didLeave = false;
  
    // Detect when the user leaves the tab (switches to the app)
    const handleBlur = () => {
      didLeave = true;
    };
  
    window.addEventListener("blur", handleBlur);
  
    // Try opening the app using deep link
    const link = document.createElement("a");
    link.href = appLink;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  
    // Wait for 1.2 seconds to check if the user left the browser
    setTimeout(() => {
      window.removeEventListener("blur", handleBlur); // Cleanup
  
      // If the user DID NOT leave the browser, redirect to download link
      if (!didLeave) {
        window.location.href = OpenAppLink;
      }
    }, 600);
  };
  useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl.includes(APP_URL)){
      setTimeout(() => {
	      window.location.href = fallbackLink;
      }, 1200);
    }
  }, []);

	useEffect(() => {
		if (os !== "Other" && appDownloadSession !== "1") {
			const timer = setTimeout(() => {
				setShowModal(true);
			}, 20000); // 20 seconds
			return () => clearTimeout(timer);
		}
	}, [os, appDownloadSession]);

  return (
    <>
	    {showModal && !closeModal ? (
        <Modal style={closeModal ? { 'display': 'none' } : {}} onClick={handleCloseModal}>
          <ModalContent>
            <div class='d-flex justify-content-end'>
              <button class="close" onClick={handleCloseModal}>×</button>
            </div>
            <div class="content-body">
              <ShopLogoContainer>
                {/* <img src="/static/media/delishop_logo.ce58b453.svg" alt="delishop" width="227" height="79"></img> */}
                <img src={DelishopLogo} alt="delishop" width="227" height="79"></img>
              </ShopLogoContainer>
              {/* <h6 class="text-center my-4">Download our mobile App for better User Experience</h6> */}
              <h6 className="text-center my-4">Do you want to continue on Delishop app?</h6>
              <div className="d-flex justify-content-center">
                <Button onClick={handleClickOpenApp} size="small" variant="contained" style={{ color: '#ffffff', backgroundColor: '#9cc54b' }} > Open App </Button>
                &nbsp;
                <Button onClick={handleCloseModal} size="small" variant="contained" style={{ color: '#ffffff', backgroundColor: '#999999' }} > Stay On Browser </Button>
              </div>

            </div>
          </ModalContent>
        </Modal>

      ) : ('')}
    </>
  );
};

export default DownloadAppPopupV2;
